import type {
  AccountantPerformanceInsightsDTO,
  AccountantStatusSummaryDTO,
  MonthDetailBillsDTO,
  MonthDetailInvoicesDTO,
  MonthDetailTransactionsDTO,
  WorkHistoryItemDTO,
} from "../models/accountantStatusDto";
import type {
  AccountantStatusBillsDetailEntity,
  AccountantStatusInvoicesDetailEntity,
  AccountantPerformanceInsightsEntity,
  AccountantStatusSummaryEntity,
  AccountantStatusTransactionsDetailEntity,
  AccountantStatusWorkHistoryEntity,
} from "../../domain/entities/AccountantStatusEntity";

export function accountantStatusSummaryDtoToEntity(
  dto: AccountantStatusSummaryDTO,
): AccountantStatusSummaryEntity {
  return dto;
}

export function accountantStatusBillsDetailDtoToEntity(
  dto: MonthDetailBillsDTO,
): AccountantStatusBillsDetailEntity {
  return {
    ...dto,
    pagination: dto.pagination
      ? {
          total: dto.pagination.total,
          limit: dto.pagination.limit,
          offset: dto.pagination.offset,
          hasMore: dto.pagination.has_more,
        }
      : undefined,
  };
}

export function accountantStatusInvoicesDetailDtoToEntity(
  dto: MonthDetailInvoicesDTO,
): AccountantStatusInvoicesDetailEntity {
  return {
    ...dto,
    pagination: dto.pagination
      ? {
          total: dto.pagination.total,
          limit: dto.pagination.limit,
          offset: dto.pagination.offset,
          hasMore: dto.pagination.has_more,
        }
      : undefined,
  };
}

export function accountantStatusTransactionsDetailDtoToEntity(
  dto: MonthDetailTransactionsDTO,
): AccountantStatusTransactionsDetailEntity {
  return dto;
}

export function accountantStatusWorkHistoryDtoToEntity(
  dto: WorkHistoryItemDTO,
): AccountantStatusWorkHistoryEntity {
  return dto;
}

export function accountantPerformanceInsightsDtoToEntity(
  dto: AccountantPerformanceInsightsDTO,
): AccountantPerformanceInsightsEntity {
  return dto;
}
